// extracted by mini-css-extract-plugin
module.exports = {"icons":"menu-bar_icons__2d3l-","inActiveDelBtn":"menu-bar_inActiveDelBtn__1D_u6","searchInput":"menu-bar_searchInput__3IAsU"};